import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LIB_partStoreData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LIB_partStoreDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LIB_partStoreDataStore",
			variables: true,
		})
	}
}

export async function load_LIB_partStoreData(params) {
  await initClient()

	const store = new LIB_partStoreDataStore()

	await store.fetch(params)

	return {
		LIB_partStoreData: store,
	}
}
